// extracted by mini-css-extract-plugin
module.exports = {"option":"MarketTotalOption__option___1bUqu","button":"MarketTotalOption__button___1fDcF"};